import { SlideUpModal } from "src/components/SlideUpModal";

type DependentModalProps = {
  isOpen: boolean;
  closeHandler: () => unknown;
};

export default ({ isOpen, closeHandler }: DependentModalProps) => (
  <SlideUpModal
    title="What is a dependent?"
    isOpen={isOpen}
    closeHandler={closeHandler}
    hasIcon
  >
    <p className="text-base leading-[22.4px] text-[#111827]">
      A dependant (US spelling: dependent) is a person who relies on another as
      a primary source of income. A common-law spouse who is financially
      supported by their partner may also be included in this definition. In
      some jurisdictions, supporting a dependant may enable the provider to
      claim a tax deduction.
    </p>
  </SlideUpModal>
);
